import { uuid } from '../utils';
import {
  COMICS
} from './categories';

export default {
  id: uuid(),
  priority: 3,
  name: 'Colour Pictures',
  thumbnail: './ColourPictures/00_Thumb.jpg',
  categories: [ COMICS ],
  content: [
    './ColourPictures/01-title.jpg',
    './ColourPictures/02.jpg',
    './ColourPictures/03.jpg',
    './ColourPictures/04.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/colourpictures.js